import {
  login,
  logout,
  getInfo,
  leftList,
  getSystem
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import router, {
  resetRouter
} from '@/router'

const state = {
  token: '',
  name: '', // 名称
  avatar: '', // 头像
  introduction: '', // 用户介绍
  roles: [], // 用户权限名称（admin）
  list: [] // 权限列表
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },

  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_LIST: (state, data) => {
    state.list = data
  }
}

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    const {
      username,
      password
    } = userInfo
    return new Promise((resolve, reject) => {
      login({
        userName: username.trim(),
        password: password,
        country: 'CN',
        identityType: 'EMP'
      })
        .then((response) => {
          // console.log(response);
          if (response) {
            const {
              data
            } = response
            commit('SET_TOKEN', data.data.token)
            // console.log(data.data);
            // console.log(data.data,'0000');
            localStorage.setItem('changpanUser', data.data.roleCode)
            sessionStorage.setItem('changpanUserId', data.data.userId)

            setToken(data.data.token)
            resolve(data)
          } else {
            resolve()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getInfo(
        {
          identityType: 'EMP'
        }
      )
        .then((response) => {
          const {
            data
          } = response
          sessionStorage.setItem('roleCode',data.data.roleCode)
          window.sessionStorage.setItem("imAppId", data.data.imAppId);
          const arr = []
          arr.push(data.userName)
          commit('SET_LIST', data)
          commit('SET_ROLES', arr)

          commit('SET_NAME', data.userName)
          commit(
            'SET_AVATAR',
            'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
          )
          commit('SET_INTRODUCTION', data.userName)
          resolve(data)

          // resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // user logout
  logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('tagsView/delAllViews', null, {
            root: true
          })

          resolve()
        })
        // .catch((error) => {
        //   reject(error)
        // })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // 动态修改权限
  async changeRoles({
    commit,
    dispatch
  }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const {
      roles
    } = await dispatch('getInfo')

    resetRouter()

    // 基于角色生成可访问路线图
    const accessRoutes = await dispatch('permission/leftList', roles, {
      root: true
    })
    // 动态添加可访问的路由
    router.addRoutes(accessRoutes)

    // 重置访问的视图和缓存的视图
    dispatch('tagsView/delAllViews', null, {
      root: true
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
